import { render, staticRenderFns } from "./ContentsTable.vue?vue&type=template&id=7442d56a&scoped=true"
import script from "./ContentsTable.vue?vue&type=script&lang=js"
export * from "./ContentsTable.vue?vue&type=script&lang=js"
import style0 from "./ContentsTable.vue?vue&type=style&index=0&id=7442d56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442d56a",
  null
  
)

export default component.exports